import {
  getTasksList,
  getTasksProgressOptions,
  InstallationProductShapes,
  postProduct
} from '@/api/config'
import config from '@/static/config'
const state = {
  params: {
    condition: {
      PageIndex: 1,
      PageSize: 10000,
      GetChildTask: false,
      GetRecycle: false,
      IsApp: false,
      OrderBy: 'LastUpdatedOn desc',
      Type: null,
      Name: null,
      Status: null,
      GroupId: null,
      DueStartTime: null,
      DueEndTime: null,
      LastUpdatedOn: null,
      AssignedUserIds: null,
      WatchingUserIds: null,
      LocationType: null
    },
    addTaskDialog: {
      showDialog: false,
      type: '0'
    },
    productDialog: {
      showDialog: false
    },
    selectPoint: {},
    taskSortby: {
      orderBy: '',
      sortBy: '',
      sortValue: ''
    }
  },
  data: {
    taskList: [],
    protobuf: null,
    roomList: [],
    addRoomList: [],
    pinList: [],
    addTaskPointList: [],
    taskShape: [],
    centerPoint: {},
    productList: [],
    roomDetail: {},
    batchTaskIds: [],
    addProductList: [],
    roomCheck: [],
    productHandleList: [],
    tasksProgressOptions: [],
    taskInstallationList: [],
    refreshTaskList: false,
    pdfToolStyle: {
      color: '#FF0000',
      strokeThickness: 4,
      highlightStrokeThickness: 48,
      fontSize: 67
    }
  }
}
const mutations = {
  setRefreshTaskList (state, obj) {
    state.data.refreshTaskList = obj
  },
  resetConiditon (state, obj) {
    for (let i in obj) {
      state.params.condition[i] = obj[i]
    }
  },
  setRoomCheck (state, arr) {
    state.data.roomCheck = arr
  },
  clearAddProductList (state) {
    state.data.addProductList = []
  },
  changeAddProductList (state, arr) {
    state.data.addProductList = arr
  },
  setAddProductList (state, obj) {
    state.data.addProductList.push(obj)
  },
  setBatchTaskIds (state, arr) {
    state.data.batchTaskIds = arr
  },
  clearRoomDetail (state) {
    state.data.roomDetail = {}
  },
  setRoomDetail (state, obj) {
    state.data.roomDetail = obj
  },
  setProductList (state, arr) {
    state.data.productList = arr
  },
  setCenterPoint (state, obj) {
    state.data.centerPoint = obj
  },
  setTaskShape (state, arr) {
    state.data.taskShape = arr
  },
  setSelectPoint (state, obj) {
    state.params.selectPoint = obj
  },
  clearAddTaskPointList (state) {
    state.data.addTaskPointList = []
  },
  setAddTaskPointList (state, obj) {
    state.data.addTaskPointList.push(obj)
  },
  setAddTaskType (state, num) {
    state.params.addTaskDialog.type = num
  },
  openAddTaskDialog (state, bool) {
    state.params.addTaskDialog.showDialog = bool
  },
  openProductTaskDialog (state, bool) {
    state.params.productDialog.showDialog = bool
  },
  setTaskCondition (state, obj) {
    state.params.condition[obj.name] = obj.data
  },
  clearTaskList (state) {
    state.data.taskList = []
  },
  setTaskList (state, arr) {
    state.data.taskList = arr
  },
  setProtobuf (state, obj) {
    state.data.protobuf = obj
  },
  setRoomList (state, arr) {
    state.data.roomList = arr
  },
  setPinList (state, arr) {
    state.data.pinList = []
    arr.forEach(ele => {
      let obj = {
        point: {
          x: ele.LocationX,
          y: ele.LocationY
        },
        pin: ele.point,
        pinColor: ele.color,
        taskId: ele.TaskId,
        taskType: ele.TaskType,
        taskSubtype: ele.TaskSubtype
      }
      if (ele.LocationType === 2) {
        obj.position = 'Wall'
      }
      state.data.pinList.push(obj)
    })
  },
  setAddRoomList (state, arr) {
    state.data.addRoomList = []
    state.data.addRoomList = arr
  },
  clearAddRoomList (state) {
    state.data.addRoomList = []
  },
  setProductHandleList (state, arr) {
    state.data.productHandleList = arr
  },
  setTasksProgressOptions (state, arr) {
    state.data.tasksProgressOptions = arr
  },
  getTaskInstallationList (state, arr) {
    state.data.taskInstallationList = arr
  },
  setPdfToolStyle (state, style) {
    state.data.pdfToolStyle = style
  },
  setTaskSortby (state, obj) {
    state.params.taskSortby = obj
  },
  clearTaskSortby (state, obj) {
    state.params.taskSortby.sortBy = ''
    state.params.taskSortby.sortValue = ''
  }
}
const getters = {
}
const actions = {
  postProduct ({ state, commit, rootState }, productList) {
    let array = []
    for (let i of productList) {
      let param = {
        ProjectId: rootState.plan.LinkProjectId,
        SKU: i.id,
        Color: i.color ? config.colorRGB2Hex(i.color) : '#ffffff',
        AssignType: i.assignType,
        Unit: config.getUnit(i.unit),
        ProductType: config.getProductNum(i.type),
        Trade: i.trade,
        IsDeleted: false
      }
      array.push(param)
    }
    postProduct(array).then(res => {
      commit('setProductList', productList)
    })
  },
  getTasksList ({ state, commit, rootState }) {
    return new Promise((resolve, reject) => {
      state.params.condition.JobsiteId = rootState.jobsiteID
      state.params.condition.PlanId = rootState.plan.PlanId
      getTasksList(state.params.condition).then(res => {
        commit('setPinList', config.handleTaskList(res.Data))
        commit('setTaskList', config.handleTaskList(res.Data))
        resolve()
      })
    })
  },
  search ({ state, commit, dispatch }, condition) {
    for (let i in condition) {
      if (condition[i] === '') {
        condition[i] = null
      }
      state.params.condition[i] = condition[i]
    }
    dispatch('getTasksList')
  },
  getTasksProgressOptions ({ state, commit }) {
    getTasksProgressOptions().then(res => {
      res.forEach(ele => {
        ele.Key = parseFloat(ele.Key)
        ele.Value = ele.Value + '%'
      })
      commit('setTasksProgressOptions', res)
    })
  },
  InstallationProductShapes ({ commit, rootState, dispatch }) {
    let params = {
      planId: rootState.plan.PlanId,
      jobsiteId: rootState.jobsiteID
    }
    InstallationProductShapes(params).then(res => {
      commit('getTaskInstallationList', res)
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
